import(/* webpackMode: "eager" */ "/codebuild/output/src1227593752/src/apps/webapp/src/app/global-error.tsx");
